import {openModal, pathIs, url} from "../utilities";
import Spinner from "../spinner";
import {toastAlert} from "../toastAlert";
import axios from "axios";
import {enableFormBack, fillFormInputs} from "../forms";
import {confirmModal} from "../confirmModal";
import * as $ from "jquery";
import {round} from "@popperjs/core/lib/utils/math";

export const reports_page = () => {
    if(pathIs([
        '/app/reports/regional/*/add-district*',
        '/app/reports/regional/*/items/*/edit*',
        '/app/reports/asf/*/add-district*',
        '/app/reports/asf/*/items/*/edit*',
    ])) {
        let changes = false;
        let form = $('#add_regional_report_items, #edit_regional_report_items, #add_asf_report_items, #edit_asf_report_items');
        let editing = window._editing === true;

        form.find('.loadable input, select').change(function() {
            changes = true;
        })

        $('.btnLoadData').click(async function() {
            if((changes || editing) && !await confirmModal('Czy na pewno chcesz załadować dane z systemu?')) {
                return;
            }

            let spinner = new Spinner();
            let district_id = $('select[name="district_id"]').val();
            let id = $('input[name="report_id"]').val();

            let type = 'regional';
            if(window._asf) {
                type = 'asf';
            }

            try {
                let response = await axios.get(url(`api/reports/${type}/${id}/data?district_id=${district_id}`));
                if(response.data.code !== 200) {
                    throw new Error();
                }

                spinner.destroy();
                fillFormInputs(form, response.data.data)
            } catch(err) {
                spinner.destroy();
                toastAlert('Wystąpił błąd podczas próby załadowania danych.', {type: 'danger'})
            }
        })

        $('.btnLoadHarmData').click(async function() {
            if((changes || editing) && !await confirmModal('Czy na pewno chcesz załadować dane z systemu?')) {
                return;
            }

            let spinner = new Spinner();
            let district_id = $('select[name="district_id"]').val();
            let id = $('input[name="report_id"]').val();

            try {
                let response = await axios.get(url(`api/reports/regional/${id}/get-harms?district_id=${district_id}`));
                if(response.data.code !== 200) {
                    throw new Error();
                }

                spinner.destroy();
                fillFormInputs(form, response.data.data)
            } catch(err) {
                spinner.destroy();
                toastAlert('Wystąpił błąd podczas próby załadowania danych.', {type: 'danger'})
            }
        })

    }

    if(pathIs([
        '/app/reports'
    ])) {

        $(".btnExportToExcel").click(function(){
            let form = $(this).closest('form');
            let url = form.prop('action');
            url = url + '?to_excel=true';
            form.prop('action', url);
            form.submit();
            enableFormBack();
        })

        $(".btnExportToPdf").click(function(){
            let form = $(this).closest('form');
            let url = $(this).data('url');
            form.prop('action', url);
            form.submit();
        })
    }

    if(pathIs([
        '/app/reports/activity'
    ])){
        $("#activityReportsTable").DataTable({
            order: [0, 'desc'],
            stateSave: false
        });

        $(".btnCheckMails").click(async function () {

            let id = $(this).data('id');
            try {
                let response = await axios.get(url(`api/reports/activity/${id}/mails`));
                let modalNode = $('#activityReportMailsModal');
                let table = modalNode.find('table');
                let span = modalNode.find('span');
                if(table){
                    table.remove();
                }
                if(span){
                    span.remove();
                }
                openModal(modalNode);
                let modalBody = modalNode.find('.modal-body')

                if(response.data.mails.length === 0) {
                    modalBody.append(`<span>Ten raport nie został jeszcze wysłany.</span>`)
                }else {

                    let table = $(`
                        <table class="table table-striped w-100">
                            <thead>
                            <tr>
                                <th>Data wysłania</th>
                                <th>Adresat</th>
                                <th>Adres email</th>
                                <th>Status</th>
                            </tr>
                            </thead>
                        </table>
                    `)

                    let tbody = $(`
                        <tbody></tbody>
                    `)

                    for (let mail of response.data.mails) {
                        let tr = $(`
                    <tr>
                        <td>${mail.created_at}</td>
                        <td>${mail.name}</td>
                        <td>${mail.email}</td>
                        <td>${mail.status_name}</td>
                    </tr>
                     `)

                    tbody.append(tr);

                    }
                    table.append(tbody);
                    modalBody.append(table);
                }


            }catch (e){
                toastAlert('Nie udało się załadować danych. Spróbuj ponownie później', {type:"danger"})
            }

        });
    }

    if(pathIs([
        '/app/reports/harm*',
    ])) {
        $("#harmsTable").DataTable({
            stateSave: false,
            order: [0, 'desc'],
            filters: {
                columns: [
                    {
                        index: 6,
                        title: 'Status'
                    }
                ]
            },
        });

        $("#generateHarmReport").on('submit', function(e){
            e.preventDefault();
            let spinner = new Spinner();
            this.submit();
            spinner.destroy();
            enableFormBack();
        })

        $('.btnDetailsModal').click(function(){
            let that = $(this);
            $('.initial').html(that.data('initial'));
            $('.gather').html(that.data('gather'));
            $('.final').html(that.data('final'));
            $('.destruction').html(that.data('destruction'));
            $('.surface').html(that.data('surface'));
            $('.payment').html(that.data('payment'));
            $('.comments').html(that.data('comments'));
            $('.cultivation').html(that.data('cultivation'));
            $('.type').html(that.data('type'));

        })

        $('#editHarmReport_destruction_percentage, #editHarmReport_surface').change(function () {
            let reduced = $('#editHarmReport_reduced_surface');
            let percentage = $('#editHarmReport_destruction_percentage').val();
            let surface = $('#editHarmReport_surface').val();

            if(percentage && percentage > 0 && surface && surface > 0){
                reduced.val(round(percentage/100 * surface * 100) / 100);
            }
        })
        $('#addHarmReport_destruction_percentage, #addHarmReport_surface').change(function () {
            let reduced = $('#addHarmReport_reduced_surface');
            let percentage = $('#addHarmReport_destruction_percentage').val();
            let surface = $('#addHarmReport_surface').val();

            if(percentage && percentage > 0 && surface && surface > 0){
                reduced.val(round(percentage/100 * surface * 100) / 100);
            }
        })


    }


}
